"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initState = exports.INITIAL_SPORT_ID = void 0;
const api_1 = require("astra-core/utils/api");
const types_1 = require("./types");
exports.INITIAL_SPORT_ID = 0;
exports.initState = {
    [types_1.EventType.TOP_LINE]: {
        eventsIdsBySport: {},
        fetchItems: api_1.requestInitialState,
    },
    [types_1.EventType.TOP_LIVE]: {
        eventsIdsBySport: {},
        fetchItems: api_1.requestInitialState,
    },
    currentSportIds: {
        [types_1.EventType.TOP_LINE]: exports.INITIAL_SPORT_ID,
        [types_1.EventType.TOP_LIVE]: exports.INITIAL_SPORT_ID,
        [types_1.EventType.UPCOMING]: exports.INITIAL_SPORT_ID,
    },
};
//# sourceMappingURL=constants.js.map